module.exports = __webpack_public_path__ + "static/media/chat.76a38359.svg";